export default function Landing(props: any) {
    return (
        <iframe src="https://crm.flourishos.com/v2/preview/mFzugHWR3ssWy5eL6634" style={{ width: '100vw', height: '100vh' }} />
    )
}